import { createReactRenderer } from 'helpers/react-renderer';
import PaymentFactory from 'app/src/payments/PaymentFactory';
import PaymentTypeManager from 'app/src/payments/PaymentTypeManager';
import PaymentAnalytics from 'app/src/payments/PaymentAnalytics';
import RetailManager from 'app/retail_manager/RetailManager';
import TerminalPaymentModal from './components/TerminalPaymentModal';
import { QuickPayCashModal } from './components/QuickPayCashModal';

// eslint-disable-next-line
let _quickPayCashModal = null;
// eslint-disable-next-line
let _quickPayCreditModal = null;

export function doCashQuickPay(saleManager) {
  PaymentAnalytics.trackGenericPaymentEvent('QuickPay Cash', 'Start', saleManager.sale.id);

  // We make sure to refresh the sale right before rendering the quick-pay modal
  // This fix an issue where the merchant is editing the quantity
  // and clicks on the Card or Cash button without giving
  // enough time to the sale manager to update
  const RenderedComponent = createReactRenderer({
    component: QuickPayCashModal,
    selector: '[data-react-root="ReactModal"]',
    props: {
      onHide: () => {
        _quickPayCashModal = null;
        RenderedComponent.unmount();
      },
      onFinishSale: cashAmount =>
        new Promise((resolve, reject) => {
          saleManager
            .addPayment(PaymentFactory.createPayment(PaymentTypeManager.Types.CASH, cashAmount))
            .done(() => {
              window.merchantos.register
                .completeSale()
                .done(() => {
                  PaymentAnalytics.trackGenericPaymentEvent(
                    'QuickPay Cash',
                    'Completed',
                    saleManager.sale.id
                  );

                  resolve();
                })
                .fail(() => {
                  reject('The sale could not be completed.');
                });
            })
            .fail(() => {
              reject('Could not add the payment to the sale.');
            });
        }),
      // We can only have one cash payment in the sale so let's eliminate the current affect
      // of cash payments from the sale so that we can treat the lump sum a bit more succinctly.
      saleManager,
    },
  });
  _quickPayCashModal = RenderedComponent.mount();
}

export function doCreditQuickPay({
  saleManager,
  paymentProvider,
  amount = null,
  tipAmount = null,
  terminal = null,
} = {}) {
  PaymentAnalytics.trackGenericPaymentEvent('QuickPay Credit', 'Accessed', saleManager.sale.id);

  const RenderedComponent = createReactRenderer({
    component: TerminalPaymentModal,
    selector: '[data-react-root="ReactModal"]',
    props: {
      onHide: () => {
        _quickPayCreditModal = null;
        RenderedComponent.unmount();
      },
      onPaymentComplete: () =>
        new Promise((resolve, reject) => {
          if (saleManager.pendingBalance.isZero()) {
            window.merchantos.register
              .completeSale()
              .done(() => {
                resolve();
              })
              .fail(() => {
                reject('Sale not completed');
              });
          } else {
            // still have an outstanding balance for some reason so
            // take the user to the regular payments screen
            window.merchantos.register.donePay();
            resolve();
          }
        }),
      analyticsName: 'Quick Pay',
      initialAmount: amount || saleManager.pendingBalance,
      saleManager,
      paymentProvider,
      autoFinishSale: true,
      ...(terminal && { terminal }),
      ...(tipAmount && { tipAmount }),
    },
  });
  _quickPayCreditModal = RenderedComponent.mount();
}

export function setQuickPayState(saleManager, paymentProvider) {
  if (!RetailManager.active) {
    const { saleTotal, pendingPaymentsTotal, deposits } = saleManager;
    const quickPayDisabled =
      saleTotal.isZero() ||
      !pendingPaymentsTotal.isZero() ||
      !deposits.depositTotal.isZero() ||
      !deposits.refundTotal.isZero();

    if (quickPayDisabled) {
      window.merchantos.keyboard.unsubscribe('Alt+.');
      window.merchantos.keyboard.unsubscribe('Alt+,');
    } else {
      window.merchantos.keyboard.subscribe('Alt+.', () => {
        doCashQuickPay(saleManager);
      });
      window.merchantos.keyboard.subscribe('Alt+,', () => {
        doCreditQuickPay(saleManager, paymentProvider);
      });
    }

    $('#creditQuickPay').prop('disabled', quickPayDisabled);
    $('#cashQuickPay').prop('disabled', quickPayDisabled);

    $('#quickPay').toggleClass('hidden', saleManager.isRefundSale());
  }
}
